<template>
  <div v-rect-loading="loading" class="personal-interview">
    <div class="left">
      <div class="title">{{ $t(`${i18nPrefix}.title.interview`) }}</div>
      <div class="info">
        <div class="info-title">{{ $t(`${i18nPrefix}.label.information`) }}</div>
        <div v-for="(info, index) in interviewInfoList" class="info-item" :key="index">
          <div class="label">{{ info.label }}</div>
          <div class="value">{{ info.value }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-title">{{ interviewTimeLabel }}</div>
      <div class="interview-time">
        <template v-if="interviewStatus === INTERVIEW_STATUS.PENDING_CANDIDATE_SELECT_TIME">
          <div
            v-for="(time, index) in availableInterviewTimeList"
            class="interview-time-item"
            :class="selectedTime === time && 'is-selected'"
            :key="index"
            @click="handleSelectInterviewTime(time)"
          >
            <div class="date">{{ formatDate(time.startDate) }}</div>
            <div class="time-range">{{ formatDateTime(time.startDate, time.startTime, time.endTime) }}</div>
          </div>
        </template>
        <div v-else-if="isInterviewScheduled" class="interview-time-item is-selected">
          <div class="date">{{ formatDate(interviewedTime.startDate) }}</div>
          <div class="time-range">{{ formatDateTime(interviewedTime.startDate, interviewedTime.startTime, interviewedTime.endTime) }}</div>
        </div>
        <div v-else-if="interviewStatus === INTERVIEW_STATUS.RESCHEDULING_BY_CANDIDATE" class="suggest-new-time">{{ $t(`${i18nPrefix}.label.suggestedNewTime`) }}</div>
        <div v-else-if="isInterviewCanceled" class="canceled">{{ $t(`${i18nPrefix}.label.canceled`)}}</div>
      </div>
      <div v-if="!hiddenBtn" class="btn-group">
        <el-button class="cancel-btn common-btn" @click="handleCancelInterview">{{ $t('common.btn.cancel') }}</el-button>
        <el-button v-if="showSuggestBtn" class="suggest-btn common-btn" @click="handleSuggestTime">{{ $t(`${i18nPrefix}.btn.suggestTime`) }}</el-button>
        <el-button v-if="showConfirmBtn" class="confirm-btn" type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
      </div>
    </div>
    <DialogWrapper
      :show.sync="cancelDialog.show"
      :loading="cancelDialog.loading"
      :title="$t(`${i18nPrefix}.label.cancelInterview`)"
      @save="confirmCancelInterview"
    >
    </DialogWrapper>
    <DialogWrapper
      :show.sync="suggestDialog.show"
      :loading="suggestDialog.loading"
      :title="$t(`${i18nPrefix}.label.suggestInterview`)"
      @save="confirmSuggestInterview"
    >
    </DialogWrapper>
  </div>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import mixin from '../mixin'

export default {
  components: { DialogWrapper },
  mixins: [mixin]
}
</script>

<style scoped lang="scss">
.personal-interview {
  display: flex;
  margin: 40px auto 0;
  width: 1040px;
  background: #ffffff;
  box-shadow: 0 0 12px 5px rgba(203, 203, 203, 0.23);
  border-radius: 10px;
  min-height: 690px;

  .left {
    border-right: 1px solid #e5e5e5;
    width: 330px;

    .title {
      padding: 40px 0 30px 40px;
      font-weight: 600;
      font-size: 20px;
      color: #000000;
      line-height: 28px;
      border-bottom: 1px solid #e5e5e5;
    }

    .info {
      padding-top: 25px;
      padding-left: 40px;

      .info-title {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: 22px;
      }

      .info-item {
        margin-top: 20px;

        .label {
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }

        .value {
          margin-top: 4px;
          font-size: 14px;
          color: #000;
          line-height: 20px;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 40px 30px;

    .content-title {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
    }

    .interview-time {
      padding-left: 70px;
      padding-right: 90px;
      margin-top: 58px;

      .interview-time-item {
        width: 492px;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        border: 1px solid rgba(0, 150, 204, 0.3);
        color: #0096cc;
        box-sizing: border-box;
        cursor: pointer;

        &.is-selected,
        &:hover {
          background: rgba(0, 150, 204, 0.1);
          border-radius: 4px;
          border-width: 0;

          .date, .time-range {
            font-weight: 500;
          }
        }

        & + .interview-time-item {
          margin-top: 20px;
        }

        .date, .time-range {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .suggest-new-time,
      .canceled {
        font-size: 14px;
        line-height: 20px;
        color: #666;
        text-align: center;
        padding-top: 128px;
      }
    }

    .btn-group {
      display: flex;
      margin-top: auto;

      .common-btn {
        min-width: 160px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #0096cc;
        color: #0096cc;

        &:hover {
          background: rgba(0, 150, 204, 0.1);
        }
      }

      .confirm-btn {
        display: block;
        min-width: 160px;
        height: 48px;
        margin-left: auto;
      }

      .el-button {
        &:last-child {
          margin-left: auto;
        }
      }
    }
  }
}
</style>
